import { useRef } from 'react';
import { useElementWidth } from '../hooks';

// Renders a fixed-size design (w×h) scaled to the width of its container,
// so product mock-ups keep their exact proportions at any size.
export default function Fit({ w, h, className = '', children }) {
  const ref = useRef(null);
  const width = useElementWidth(ref);
  const scale = width / w;

  return (
    <div ref={ref} className={`fit ${className}`} style={{ position: 'relative', height: h * scale }}>
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: w,
          height: h,
          transform: `scale(${scale})`,
          transformOrigin: '0 0',
          visibility: width ? 'visible' : 'hidden',
        }}
      >
        {children}
      </div>
    </div>
  );
}
